import Modal from '@mui/material/Modal';
import { Box } from '@mui/system'
import { useTheme } from '@emotion/react'

const ModalBox = ({ children, open, onClose }) => {
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        minWidth: '40%',
        maxWidth: '40%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        boxShadow: 4,
        borderRadius: 3,
        p: 4,
        outline: "none",
        maxHeight: "88vh",
        overflow: 'hidden',

        '@media (max-width: 1200px)': {
            width: '80%',
            maxWidth: '80%',
            marginLeft: "auto",
            marginRight: "auto",
        },
        '@media (max-width: 425px)': {
            width: '82%',
            maxWidth: '82%',
            marginLeft: "auto",
            marginRight: "auto",
            p: 2
        },
    };
    const theme = useTheme()
    return (
        <Modal
            open={open}
            onClose={onClose}
        >
            <Box className={theme.palette.mode === "dark" ? ['modal-background'] : ""} sx={style}>
                {children}
            </Box>
        </Modal>
    )
}

export default ModalBox